import Bridge from 'src/frontend-lib/lib/Bridge'
import Mp from './mp.js'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform.js'
const myBridge = new Bridge()
const mp = new Mp()
const isApp = getPlatform().isYixinliApp

export default {
  openWebView(options) {
    if (typeof options === 'string') {
      // throw new Error('openWebView需要url参数挂载在options上')
      options = {
        url: options
      }
    }
    options = {
      isCurrentPageOpen: 0,
      ...options
    }

    if (isApp) {
      // 如果是协议，不走openWebview
      // 除文章页 m.xinli001.com/info/  www.xinli001.com/info/  客户端会通过a标签跳转来特殊处理
      if (
        options.url.indexOf('yixinli://') === 0 ||
        options.url.indexOf('muse://') === 0 ||
        options.url.includes('.xinli001.com/info/')
      ) {
        window.location.href = options.url
        return
      }

      if (options.url.indexOf('http') !== 0) {
        // 如果缺少协议头
        options.url =
          window.location.protocol +
          (options.url.indexOf('//') === 0 ? '' : '//') +
          options.url
      }

      myBridge.call('openWebView', options)
      // window.location.href = options.url;a
    } else if (Mp.isWebviewMp) {
      mp.openWebView(options)
    } else {
      window.location.href = options.url
    }
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/utils/router.js